import React, { createContext, useReducer } from "react";
import { reducer } from "./reducer";
import { initialState } from "./state";

export const CounterCtx = createContext();

function CounterContext({ children }) {
	const [state, dispatch] = useReducer(reducer, initialState);

	return (
		<CounterCtx.Provider value={{ state, dispatch }}>
			{children}
		</CounterCtx.Provider>
	);
}

export default CounterContext;
